export default __webpack_public_path__ + "static/perfective-habitual-past-46f2f33fb4e539440145f8f2cf6842a0.svg";